import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/stickers/sticker-printemps-pour-la-planete.svg")